module.exports = __webpack_public_path__ + "static/media/MOV.3f3513a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/MOV.svg
// module id = 1681
// module chunks = 17